import styled from 'styled-components';

import { ContentWrapper as AcceptTermsAndConditionsContentWrapper } from '../accept_terms_and_conditions/index.styles';

export {
  ButtonWrapper,
  Footer,
  ScrollContainer,
  Wrapper,
} from '../accept_terms_and_conditions/index.styles';

export const ContentWrapper = styled(AcceptTermsAndConditionsContentWrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--background);
  text-align: center;
`;

export const Icon = styled.div`
  margin: 48px 0;
`;

export const Title = styled.div`
  margin: 0;
  font-family: Butler, serif;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  white-space: pre-wrap;
`;

export const Description = styled.p`
  margin: 0;
  margin-top: 24px;
`;

export const Hint = styled.div`
  margin: 0 0 var(--gap);
  font-size: 16px;
  font-weight: 600;
`;
